import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

class CheckBox extends React.Component {
  constructor(props) {
    super(props);
    if (props.value)//if store has value relative to this component, initialize the state value
      this.state = { value: props.value, error: "" };
    else//in case the store does not have any value for this component, just clear it
      this.state = { value: "", error: "" };
  }
  componentWillReceiveProps(props) {
    if (props.error != this.state.error)
      this.setState({ error: props.error });
  }
  change(e) {
    this.props.dispatch({ type: 'checkbox', name: this.props.name, value: +e.target.checked });
  }
  render() {
    const p = this.props;
    const e = this.state && this.state.error;
    return (
      <div className="checkbox" style={{ display: p.display ? '' : 'none' }}>
        <label className="label-normal">
          <input type="checkbox" name={p.name} checked={p.value} onChange={(e) => this.change(e)} disabled={p.disabled} />
          {e ? <span className="validationMessage"><i className="fa fa-times" /> Please tick this box </span> : null}
          <span dangerouslySetInnerHTML={{ __html: p.title }} />
        </label>
      </div>
    );
  }
}
CheckBox.propTypes = {
  dispatch: PropTypes.func,
  value: PropTypes.number,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  display: PropTypes.bool
};

CheckBox.defaultProps = {
  display: true
};
const mapStateToProps = (state, props) => {
  return {
    value: state.form && state.form[props.name],
    error: state.form && state.form.errors && state.form.errors[props.name],
  };
};
export default connect(mapStateToProps)(CheckBox);